/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const WordBrainstormActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.BrainStormDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionWordBrainStormDialogHeader'),
    secondaryContent: strings.getString('trialconversionWordBrainStormDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionWordCard', 'Enhance your writing clicked'),
    retriggerable: true
});
